import React, { useState, useEffect } from 'react';
import "./AuthByOtp.css";
import { Button, Form, Col, Row, Spinner, Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import axios from "axios";
import { useNavigate } from 'react-router-dom';

const AuthByOtp = () => {
    const [email, setEmail] = useState(localStorage.getItem("email") || "");
    const [days, setDays] = useState(localStorage.getItem("days") || "");
    const [username, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [expireTime, setExpireTime] = useState(""); // minutes
    const [optApiFlag, setOptApiFlag] = useState(false);
    const [otpSent, setOtpSent] = useState(false);
    const [timeLeft, setTimeLeft] = useState(0);
    const [otp, setOtp] = useState("");
    const finalOtp = otp; // no need to join anymore
    const [isLoadingSendOtp, setIsLoadingSendotp] = useState(false);
    const [isLoadingVerifyOtp, setIsLoadingVerifyOtp] = useState(false);
    const [showPassword, setShowPassword] = useState(false);


    const navigate = useNavigate();

    const sendOtp = async (e) => {
        e.preventDefault();
        const sendOtpApi = `${process.env.REACT_APP_API_LINK}/api/v1/auth/sendOtp`;
        setIsLoadingSendotp(true)
        try {
            const res = await axios.post(sendOtpApi, {
                username:localStorage.getItem("username") || "",
                email,
            });
            toast.success(res.data.message)
            setOtpSent(true);
            setOptApiFlag(true); //  Verify button show
            const minutes = res.data.time
            setExpireTime(minutes)
            setTimeLeft(minutes * 60);
            // console.log("OTP Sent:", res.data);
        } catch (error) {
            console.log(error?.response?.data);
        } finally {
            setIsLoadingSendotp(false)
        }
    };

    //  opt handle function 

    const handleOtpChange = (e) => {
        const value = e.target.value;
        if (/^[a-zA-Z0-9!@#$%^&*_-]*$/.test(value) && value.length <= 10) {
            setOtp(value);
        }
    };
    //
    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            document.getElementById(`otp-${index - 1}`).focus();
        }
    };

    const verifyOtp = async () => {
        const verifyOtpApi = `${process.env.REACT_APP_API_LINK}/api/v1/auth/verifyOtp`
        setIsLoadingVerifyOtp(true)
        try {
            const res = await axios.post(verifyOtpApi, {
                username:localStorage.getItem("username") || "",
                // password,
                email,
                otp: finalOtp,
                days,
            });
            toast.success(res.data.message)
            // console.log("OTP Verified:", res.data);
            navigate("/")
        } catch (error) {
            console.log(error?.response?.data);
            toast.error(error?.response?.data?.message)
        } finally {
            setIsLoadingVerifyOtp(false)
        }
    };



    // show time on scrren verify otp

    useEffect(() => {
        if (expireTime) {
            setTimeLeft(expireTime * 60); // convert minutes to seconds
        }
    }, [expireTime]);

    useEffect(() => {
        if (timeLeft <= 0) return;

        const timer = setInterval(() => {
            setTimeLeft((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [timeLeft, otpSent]);

    const formatTime = () => {
        const mins = Math.floor(timeLeft / 60);
        const secs = timeLeft % 60;

        return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
    };

    return (
        <>
            <div
                style={{
                    backgroundImage: "url(/Assets/mogWh1.webp)",
                    width: "100%",
                    height: "100vh",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    position: "relative",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <div className='auth-form-background'>
                    <div className='auth-header'>
                        <h1>User Verification</h1>
                    </div>
                    <div className='auth-form-container'>
                        <Form>
                            {/* {optApiFlag && (
                                <div className='auth-field-container'>
                                    <div className='auth-inputTag-container'>
                                        <div>
                                            <label>Username:</label>
                                            <span className="compulsorily">*</span>
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control mt-1"
                                            placeholder="Enter Username"
                                            name="username"
                                            autoComplete="off"
                                            value={username}
                                            onChange={(e) => setUserName(e.target.value)}
                                        />
                                    </div>
                                    <div className="auth-inputTag-container">
                                        <div>
                                            <label>Password:</label>
                                            <span className="compulsorily">*</span>
                                        </div>
                                        <div style={{ position: "relative" }}>
                                            <input
                                                type={showPassword ? "text" : "password"}
                                                className="form-control mt-1"
                                                placeholder="Enter Password"
                                                name="password"
                                                autoComplete="off"
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                            />

                                            <i
                                                className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"
                                                    }`}
                                                onClick={() => setShowPassword(!showPassword)}
                                                style={{
                                                    position: "absolute",
                                                    right: "15px",
                                                    top: "50%",
                                                    transform: "translateY(-50%)",
                                                    cursor: "pointer",
                                                    color: "#666",
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )} */}

                            {/* {!optApiFlag && ( */}
                            <div className='auth-field-container'>
                                <div className='auth-inputTag-container'>
                                    <div>
                                        <label>Email:</label>
                                        <span className="compulsorily">*</span>
                                    </div>
                                    <input
                                        style={{ cursor: "not-allowed" }}
                                        type="email"
                                        className="form-control mt-1 "
                                        placeholder="Enter Email"
                                        name="email"
                                        autoComplete='off'
                                        value={email}
                                        onChange={(e) => {
                                            setEmail(e.target.value);
                                            localStorage.setItem("email", e.target.value);
                                        }}
                                        disabled
                                    />
                                </div>
                                <div className='auth-inputTag-container'>
                                    <div>
                                        <label>Number Of Days:</label>
                                        <span className="compulsorily">*</span>
                                    </div>
                                    <input
                                        style={{ cursor: "not-allowed" }}
                                        type="text"
                                        className="form-control mt-1 "
                                        placeholder="Enter Days"
                                        name="days"
                                        autoComplete='off'
                                        value={days}
                                        maxLength={3}
                                        onChange={(e) => {
                                            setDays(e.target.value);
                                            localStorage.setItem("days", e.target.value);
                                        }}
                                        disabled
                                    />
                                </div>
                            </div>
                            {/* )} */}
                            {optApiFlag && timeLeft > 0 && (
                                <div className="otp-varification-container">
                                    <div className="otp-varification-main">
                                        <input
                                            id="otp"
                                            type="text"
                                            maxLength="10"
                                            className="otp-input-single"
                                            value={otp}
                                            onChange={handleOtpChange}
                                            placeholder="Enter PASSWORD / OTP"
                                            autoComplete="off"
                                        />
                                    </div>
                                    <div className='otp-varification-time'>OTP Expires In: {formatTime(timeLeft)}</div>
                                </div>
                            )}
                            <div className="auth-btn-container">

                                {!otpSent ? (
                                    <button
                                        type="button"
                                        className="btn btn-primary auth-btn"
                                        onClick={sendOtp}
                                    >{isLoadingSendOtp ? (<div>
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                    </div>) : (

                                        "Send OTP"
                                    )
                                        }
                                    </button>
                                ) : timeLeft === 0 ? (
                                    <button
                                        type="button"
                                        className="btn btn-danger auth-btn"
                                        onClick={sendOtp}
                                    >
                                        {isLoadingSendOtp ? (<div>
                                            <span
                                                className="spinner-border spinner-border-sm"
                                                role="status"
                                                aria-hidden="true"
                                            />
                                        </div>) : (

                                            "Resend OTP"
                                        )}
                                    </button>
                                ) : (
                                    <button
                                        type="button"
                                        className="btn btn-success auth-btn"
                                        onClick={verifyOtp}
                                        disabled={otp.length !== 10}
                                        style={{
                                            cursor: otp.length !== 10 ? "not-allowed" : "pointer"
                                        }}
                                    >
                                        {isLoadingVerifyOtp ? (<div>
                                            <span
                                                className="spinner-border spinner-border-sm"
                                                role="status"
                                                aria-hidden="true"
                                            />
                                        </div>) : (

                                            "Verify OTP"
                                        )}
                                    </button>
                                )}

                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </>

    )
}

export default AuthByOtp